module.exports = __webpack_public_path__ + "static/media/property-purse-logo-black.5f913194.svg";